<template>
  <div class="search-form" style="display: flex;">
    <b-row align-h="between" style="flex: 1;">
      <b-col cols="5">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_user_table_search') ||
                  '姓名/手机号/所属分组 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-button
      v-if="isLast && allow('A')"
      type="primary"
      size="small"
      class="ml-4"
      @click="$emit('openChooseUser')"
    >
      <span>{{ $l("header_menu_add_user") || "添加成员" }}</span>
    </el-button>
    <el-button
      v-if="isLast && allow('D')"
      type="primary"
      size="small"
      class="ml-4"
      @click="$emit('delUser')"
    >
      <span>{{ $l("header_menu_del_user") || "删除成员" }}</span>
    </el-button>
    <el-button
      v-if="isTop && allow('S')"
      type="primary"
      size="small"
      class="ml-4"
      @click="$emit('syncDepUser')"
    >
      <span>{{ $l("header_menu_sync_dep_user") || "同步生产线人员" }}</span>
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    isLast: { type: Boolean, default: false },
    isTop: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { keyword: "" },
    };
  },
  created() {
    this.query();
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit("reset");

      this.$emit("query", this.form);
    },
    reset() {
      this.form = {};
    },
  },
};
</script>
